var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPupilRight = function SvgPupilRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 52,
    height: 19,
    viewBox: "0 0 1.96 0.72",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.19;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil1{fill:#000}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2370553232000"
  }, /*#__PURE__*/React.createElement("path", {
    className: "str0",
    d: "M.84.34C.87.35.76.47.72.51.44.75.32.6.09.31.32.02.53.02.84.34z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M1.11.34c-.03.01.08.13.13.17.28.24.4.09.62-.2-.22-.29-.44-.29-.75.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1.45.23c-.19.05-.06.35.11.22.12-.09 0-.25-.11-.22z"
  })))));
};

export default SvgPupilRight;